import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import WaterRightHistoryForm from '../Forms/WaterRightHistoryForm';

const AddWaterRightHistoryModal = ({ waterRightData, dataToEdit, isOpen, handleToggleModal }) => {
	return (
		<Modal
			id='showModal'
			size='lg'
			isOpen={isOpen}
			toggle={handleToggleModal}
			backdrop='static'
			centered
		>
			<ModalHeader className='bg-light p-3' toggle={handleToggleModal}>
				{dataToEdit 
					? 'Editar historial de trámite'
					: 'Registrar nuevo historial de trámite'}
			</ModalHeader>
			<WaterRightHistoryForm
				waterRightData={waterRightData}
				dataToEdit={dataToEdit}
				isOpen={isOpen}
				handleToggleModal={handleToggleModal}
			/>
		</Modal>
	);
};

export default AddWaterRightHistoryModal;
